import { UI_THEME_CONTRACT } from "./theme.contract";

function tokenColor(variable: string): string {
  return `color-mix(in srgb, var(${variable}) calc(<alpha-value> * 100%), transparent)`;
}

function contractVariable(path: string): string {
  const item = UI_THEME_CONTRACT.find((entry) => entry.path === path);
  if (!item) throw new Error(`Missing UI theme contract entry: ${path}`);
  return item.cssVariable;
}

function scaleFromContract(pathPrefix: string, aliasPrefix: string): Record<string, string> {
  const values: Record<string, string> = {};
  for (const item of UI_THEME_CONTRACT) {
    if (item.path.startsWith(pathPrefix) && item.tailwindAlias?.startsWith(aliasPrefix)) {
      values[item.path.slice(pathPrefix.length)] = `var(${item.cssVariable})`;
    }
  }
  return values;
}

const colors: Record<string, string> = {};
for (const item of UI_THEME_CONTRACT) {
  if (!item.path.startsWith("colors.") || !item.tailwindAlias?.startsWith("--color-")) continue;
  colors[item.tailwindAlias.slice("--color-".length)] = tokenColor(item.cssVariable);
}
colors["transparent"] = "transparent";
colors["current"] = "currentColor";

const spacingSteps: readonly string[] = [
  "0", "0.5", "1", "1.5", "2", "2.5", "3", "3.5", "4", "5", "6", "7", "8", "9", "10", "11", "12", "14", "16", "20", "24", "28", "32", "36", "40", "44", "48", "52", "56", "60", "64", "72", "80", "96",
];

const spacing: Record<string, string> = {};
const spacingVariable = contractVariable("spacing.unit");
for (const step of spacingSteps) spacing[step] = `calc(var(${spacingVariable}) * ${step})`;

const fontSizes = scaleFromContract("typography.fontSizes.", "--text-");
const lineHeights = scaleFromContract("typography.lineHeights.", "--leading-");
const fontWeight = scaleFromContract("typography.fontWeights.", "--font-weight-");
const letterSpacing = scaleFromContract("typography.letterSpacing.", "--tracking-");
const borderRadius = scaleFromContract("radii.", "--radius-");
const boxShadow = scaleFromContract("shadows.", "--shadow-");
const fontFamilyVariable = contractVariable("typography.fontFamily");

/** Tailwind CSS 3 preset. Configure it alongside the app's normal content globs. */
export const tailwindV3Preset = {
  theme: {
    extend: {
      colors,
      spacing,
      fontFamily: { sans: [`var(${fontFamilyVariable})`], serif: ["var(--ui-font-family-serif)"] },
      fontSize: fontSizes,
      lineHeight: lineHeights,
      fontWeight,
      letterSpacing,
      borderRadius,
      boxShadow,
    },
  },
};

export type TailwindV3Preset = typeof tailwindV3Preset;
export default tailwindV3Preset;
